import React, { useState } from "react";
import listados from "../../services/listados";
// - CORE
import {
  Grid,
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  FormHelperText,
  Paper,
} from "@material-ui/core/";
// - CORE
import { toast } from "react-toastify";
import myfunctions from "../../services/myfunctions";
import CircularProgressWithLabel from "./CircularProgressWithLabel";
// FORMIK ---------------------------------------------------------------->
import * as Yup from "yup";
import { useFormik } from "formik";
// <---------------------------------------------------------------- FORMIK

import "./styles.css";

export default function Formu(props) {
  const { id, reports } = props;
  // const { geolocation, id, reports } = props;
  const [image, setImage] = useState(null);
  const [imageSrc, setImageSrc] = useState(null);
  const [percentage, setPercentage] = useState(0);
  const [uploadLoading, setUploadLoading] = useState(false);

  const formik = useFormik({
    initialValues: {
      typeReport: "",
      commentary: "",
    },
    validationSchema: Yup.object({
      typeReport: Yup.string().required("El tipo de documento es obligatorio"),
      commentary: Yup.string().required("La descripción es obligatoria"),
    }),
    onSubmit: async (formData) => {
      try {
        setUploadLoading(true);
        if (!imageSrc) {
          toast.error("Tienes que tomar una foto.");
          setUploadLoading(false);
          return;
        }
        formData.id = id;
        myfunctions
          .updateReports(formData, image, updatePercentage)
          // .updateReports(formData, image, updatePercentage, geolocation)
          .then((result) => {
            setImage(null);
            setImageSrc(null);
            setPercentage(0);
            formik.resetForm();
            toast.success("Reporte exitoso");
            setUploadLoading(false);
          })
          .catch((error) => {
            console.log(error);
            setUploadLoading(false);
            toast.error(error);
          });
      } catch (error) {
        setUploadLoading(false);
        toast.error(error.message);
        console.log(error);
      }
    },
  });

  const handleCapture = (event) => {
    if (!event) {
      return;
    }

    const files = event.target.files;

    if (!files) {
      return;
    }

    const image = files[0];

    if (!image) {
      return;
    }

    const fileTypes = ["image/jpeg", "image/png"];

    if (!fileTypes.includes(image.type)) {
      return;
    }

    if (image.size > 20 * 1024 * 1024) {
      return;
    }
    setImage(image);
    setImageSrc(URL.createObjectURL(image));
  };

  const updatePercentage = (percentage) => {
    setPercentage(percentage);
  };

  return (
    <form noValidate autoComplete="off" onSubmit={formik.handleSubmit}>
      <Grid container spacing={2}>
        {imageSrc ? (
          <Grid item xs={12}>
            <input
              type="file"
              name="foto"
              id="foto"
              className="SubirFoto"
              accept="image/*"
              capture="camera"
              onChange={!uploadLoading && handleCapture}
            />
            <label htmlFor="foto" onChange={!uploadLoading && handleCapture}>
              <img src={imageSrc} alt="Foto" width="60%" />
            </label>
          </Grid>
        ) : (
          <Grid item xs={12}>
            <Paper>
              <div id="Selector">
                <input
                  type="file"
                  name="foto"
                  id="foto"
                  className="SubirFoto"
                  accept="image/*"
                  capture="camera"
                  onChange={!uploadLoading && handleCapture}
                />
                <label
                  htmlFor="foto"
                  onChange={!uploadLoading && handleCapture}
                >
                  <figure>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 17">
                      <path d="M10 0l-5.2 4.9h3.3v5.1h3.8v-5.1h3.3l-5.2-4.9zm9.3 11.5l-3.2-2.1h-2l3.4 2.6h-3.5c-.1 0-.2.1-.2.1l-.8 2.3h-6l-.8-2.2c-.1-.1-.1-.2-.2-.2h-3.6l3.4-2.6h-2l-3.2 2.1c-.4.3-.7 1-.6 1.5l.6 3.1c.1.5.7.9 1.2.9h16.3c.6 0 1.1-.4 1.3-.9l.6-3.1c.1-.5-.2-1.2-.7-1.5z" />
                    </svg>
                  </figure>{" "}
                  <span>Envía una foto...</span>
                </label>
              </div>
            </Paper>
          </Grid>
        )}
        <Grid item xs={12}>
          <FormControl
            variant="outlined"
            error={
              formik.errors.typeReport === undefined ||
              formik.touched.typeReport === undefined
                ? false
                : true
            }
            fullWidth
          >
            <InputLabel htmlFor="outlined-age-native-simple">
              Tipo de reporte
            </InputLabel>
            <Select
              native
              name="typeReport"
              value={formik.values.typeReport}
              onChange={formik.handleChange}
              label="Tipo de reporte"
              size="small"
              disabled={uploadLoading}
            >
              <option aria-label="None" value="" />
              {Object.values(listados.typesOfReports).map((dt, index) => {
                let disabled = true;
                if (reports) {
                  if (!reports.some((report) => report.typeReport === `${6}`)) {
                    if (index === 0 || index === 1) {
                      disabled = reports.some(
                        (report) => report.typeReport === `${index}`
                      );
                    } else {
                      disabled = false;
                    }
                  }
                } else {
                  if (index === 0) {
                    disabled = false;
                  }
                }

                return (
                  <option
                    aria-label={dt}
                    value={index}
                    disabled={disabled}
                    key={index}
                  >
                    {dt}
                  </option>
                );
              })}
            </Select>
            {formik.errors.typeReport && formik.touched.typeReport ? (
              <FormHelperText>{formik.errors.typeReport}</FormHelperText>
            ) : null}
          </FormControl>
        </Grid>
        <Grid item xs={12}>
          <TextField
            size="small"
            variant="outlined"
            required
            fullWidth
            id="commentary"
            label="Comentario"
            name="commentary"
            autoComplete="commentary"
            autoFocus
            value={formik.values.commentary}
            onChange={formik.handleChange}
            error={
              formik.errors.commentary === undefined ||
              formik.touched.commentary === undefined
                ? false
                : true
            }
            helperText={
              formik.errors.commentary && formik.touched.commentary
                ? formik.errors.commentary
                : null
            }
            multiline
            rows={4}
            disabled={uploadLoading}
          />
        </Grid>
        <Grid item xs={12}>
          <Button
            variant="contained"
            type="submit"
            color="primary"
            disabled={uploadLoading}
          >
            {percentage ? (
              <CircularProgressWithLabel value={percentage} />
            ) : (
              "Guardar"
            )}
          </Button>
        </Grid>
      </Grid>
    </form>
  );
}
